var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActiveStudent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.65,
    width: 76.0678,
    height: 76.0678,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4821 27.3111C36.2719 25.3269 39.0769 24.0503 42.2287 24.0503C47.6345 24.0503 52.0168 27.8061 52.0168 32.4401C52.0168 35.2214 50.4367 37.6866 48.0065 39.2135C47.9459 39.2506 47.8844 39.286 47.8219 39.3198V44.9829C47.8219 45.2613 47.7388 45.5334 47.5832 45.7643C47.4276 45.9951 47.2066 46.1743 46.9486 46.2789C46.6906 46.3834 46.4072 46.4085 46.1348 46.351C45.8624 46.2935 45.6134 46.156 45.4196 45.9561L43.8255 44.3145C45.3203 42.5471 46.1999 40.3769 46.1999 38.0319C46.1999 32.345 41.0289 27.6915 34.4821 27.3111V27.3111Z",
    fill: "#6371E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7755 46.2638L30.6479 51.5494C30.4541 51.7493 30.2051 51.8868 29.9327 51.9443C29.6603 52.0018 29.3769 51.9766 29.1189 51.8721C28.8609 51.7676 28.6399 51.5884 28.4843 51.3575C28.3288 51.1266 28.2456 50.8546 28.2456 50.5762V44.913C28.1832 44.8793 28.1216 44.8439 28.0611 44.8068C25.6294 43.2798 24.0507 40.8146 24.0507 38.0334C24.0507 33.3994 28.433 29.6436 33.8389 29.6436C39.2447 29.6436 43.627 33.3994 43.627 38.0334C43.627 41.8452 40.6612 45.0641 36.5991 46.0848C36.3269 46.1546 36.0522 46.2143 35.7755 46.2638V46.2638Z",
    fill: "#6371E0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveStudent);
export default __webpack_public_path__ + "static/media/active-student.ee326bbd9e2981b613a68009e8bbdc20.svg";
export { ForwardRef as ReactComponent };